import startCase from "lodash/startCase";

/**
 * Display label for a policy type. Takes the wire value as a plain string —
 * callers hold it as the v3 `InsurancePolicyType`, the benefits package's
 * `PolicyType`, or the extraction payload's own spelling, all of which share
 * the same wire values.
 */
export const selectorPolicyTypeByPolicyType = (
  policyType: string | undefined
): string => {
  return startCase(policyType);
};
